"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var HegydCore_1 = require("./hegyd/hegyd-core/HegydCore");
var BaseComponent_1 = require("../BaseComponent");
var NewsletterSide = /** @class */ (function (_super) {
    __extends(NewsletterSide, _super);
    function NewsletterSide($view) {
        var _this = _super.call(this, $view) || this;
        _this.bind();
        return _this;
    }
    NewsletterSide.prototype.bind = function () {
        this.initSliderNewsletter();
        this.sendNewsletterFrom();
        this.initEvtListeners();
    };
    NewsletterSide.prototype.sendNewsletterFrom = function () {
        $('body').on('submit', '.ttl-contact form', function (e) {
            e.preventDefault();
            var data = {
                'email': $(e.target).find('input.jsNewsletterEmail').val(),
                'accept_cgu': true
            };
            HegydCore_1.default.sendRequest($(e.target).attr('action'), 'POST', data, function (data) {
                // @ts-ignore
                Kernel.factories.Toaster($('html'), 'success', data.message);
            }, function (data) {
                // @ts-ignore
                Kernel.factories.Toaster($('html'), 'success', data.message);
            });
        });
    };
    NewsletterSide.prototype.initSliderNewsletter = function () {
        var _this = this;
        var $newsletterSide = $('#newsletterSide');
        if (window.matchMedia("(min-width: 992px)").matches) {
            $newsletterSide.on('mouseenter', function () {
                _this.slideLeft();
            }).on('mouseleave', function () {
                _this.slideRight();
            });
        }
        else {
            $newsletterSide.off("mouseenter mouseleave");
            $newsletterSide.on('click', function () {
                if ($('#newsletterBloc').css('transform') === "matrix(1, 0, 0, 1, -350, 0)") {
                    _this.slideRight();
                }
                else {
                    _this.slideLeft();
                }
            });
        }
    };
    NewsletterSide.prototype.slideRight = function () {
        if ($('#newsletterBloc').css('transform') === "matrix(1, 0, 0, 1, -350, 0)") {
            document.getElementById('newsletterBloc').animate([
                { transform: 'translateX(-350px)' },
                { transform: 'translateX(0px)' }
            ], {
                duration: 300,
                fill: "forwards"
            });
        }
    };
    NewsletterSide.prototype.slideLeft = function () {
        document.getElementById('newsletterBloc').animate([
            { transform: 'translateX(0px)' },
            { transform: 'translateX(-350px)' }
        ], {
            duration: 300,
            fill: "forwards"
        });
    };
    NewsletterSide.prototype.initEvtListeners = function () {
        var _this = this;
        window.addEventListener('resize', function () {
            _this.initSliderNewsletter();
        });
    };
    return NewsletterSide;
}(BaseComponent_1.default));
exports.default = NewsletterSide;
;
